import { Component, inject, Input, OnInit, ViewChild } from '@angular/core';
import { SelectionTableBaseComponentDirective } from '../../shared/selection-table/selection-table-base-component.directive';
import { PendingWithAlerts } from '../../biographics/pending.model';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TABLE_BASE_COMMON_IMPORTS } from '../../material-base-common-imports';
import { BehaviorSubject } from 'rxjs';
import { PermissionService } from '../../../services/permission.service';
import { take } from 'rxjs/operators';
import { MatCheckbox } from '@angular/material/checkbox';
import { RouterLink } from '@angular/router';
import { AsyncPipe, NgClass } from '@angular/common';
import { AlertTypePipe } from '../alert-type.pipe';

@Component({
  selector: 'eca-alerts-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  imports: [MatSort, MatCheckbox, MatSortHeader, RouterLink, NgClass, AsyncPipe, AlertTypePipe, ...TABLE_BASE_COMMON_IMPORTS],
})
export class AlertsTableComponent extends SelectionTableBaseComponentDirective<PendingWithAlerts> implements OnInit {
  private permissionService = inject(PermissionService);


  @ViewChild(MatSort, {static: true}) sort: MatSort;

  // Overwrite the base component data setter
  @Input() set data(alerts: PendingWithAlerts[]) {
    if (!alerts) {
      return;
    }
    this.dataSource = new MatTableDataSource(alerts);
    if (!this.sort.direction) {
      this.sort.direction = 'asc';
    }
    if (!this.sort.active) {
      this.sort.active = 'lithocode';
    }
    this.dataSource.sort = this.sort;
  }

  displayedColumns = [
    'select',
    'lithocode',
    'form',
    'stateStudentId',
    'lastName',
    'firstName',
    'alerts',
  ];

  userHasDraftVersionAce$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  ngOnInit() {
    this.permissionService.hasAnyPermission(PermissionService.ACE_TABE_LOCAL_SCANNING_UI_TESTER)
      .pipe(take(1))
      .subscribe((authorized: boolean) => {
        if (authorized) {
          this.displayedColumns.push('formEditVersion', 'formStatus');
          this.userHasDraftVersionAce$.next(authorized);
        }
      });
  }

  isAllSelected() {
    const allVisibleRows = this.dataSource.filteredData;
    const visibleDisabledRows = this.dataSource.filteredData.filter(pending => !pending.canSubmit());

    for (const row of allVisibleRows) {
      /* istanbul ignore if */
      if (visibleDisabledRows.indexOf(row) >= 0) {
        continue;
      }

      if (!this.selection.isSelected(row)) {
        return false;
      }
    }

    return true;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data
        .filter(pending => pending.canSubmit())
        .forEach(row => this.selection.select(row));
    }

    this.selected.emit(this.selection.selected);
  }

}
